import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class TokenService {

  constructor(
    private http: HttpClient
  ) { }

  obterToken(id) {
    return this.http
      .get(urls.apiBase + '/Token/ObterPorId?id=' + id);
  }

  processarVenda(id, data) {
    return this.http
      .post(urls.apiBase + '/Token/Processar?id=' + id, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/token/token.service.ts